import { render, staticRenderFns } from "./signatures.vue?vue&type=template&id=040f3908&"
import script from "./signatures.vue?vue&type=script&lang=js&"
export * from "./signatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports